import WebComponent              from 'fg-frontend/src/webComponents/WebComponent';

const FRAGMENTS = {
  SUBMENUS: '[data-fragment="MainMenu.submenu"]',
}


/**
 * Represents the main navigation menu component with dynamic submenu positioning.
 * Extends the base WebComponent class for framework integration.
 * Automatically adjusts submenu positions on initialization and window resizing.
 */
export default class MainMenu extends WebComponent {
  constructor(props) {
    super(props);
    this.setSubmenuPosition = this.setSubmenuPosition.bind(this);
    this.setSubmenuPositions = this.setSubmenuPositions.bind(this);
  }

  didMount() {
    this.submenus = this.element.querySelectorAll(FRAGMENTS.SUBMENUS);

    this.setSubmenuPositions();

    window.addEventListener('resize', this.setSubmenuPositions);
  }


  /**
   * Sets the position of the submenu relative to its parent element.
   *
   * @param {HTMLElement} element - The submenu element whose position is being set.
   * @return {void} This method does not return a value.
   */
  setSubmenuPosition(element) {
    // Nastavení přesné výšky rodiče
    const parentHeight = this.element.offsetHeight;
    element.style.top = `${parentHeight + 28}px`;
  }

  /**
   * Sets the position for all submenus in the current context.
   * Updates each submenu's position using the defined logic in setSubmenuPosition.
   *
   * @return {void} No return value.
   */
  setSubmenuPositions() {
    for (let submenu of this.submenus) {
      this.setSubmenuPosition(submenu);
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/MainMenu.js